import "./bootstrap";
import "./embla.js";

import { Alpine, Livewire } from "../../vendor/livewire/livewire/dist/livewire.esm";
import Clipboard from "@ryangjchandler/alpine-clipboard";
import Tooltip from "@ryangjchandler/alpine-tooltip";
import ui from "@alpinejs/ui";

import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de";

import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

import SignaturePad from "signature_pad";

import "livewire-sortable";

import { Html5Qrcode } from "html5-qrcode";

import { Boarding } from "boarding.js";
import "boarding.js/styles/main.css";
// optionally include the base theme
import "boarding.js/styles/themes/basic.css";

import * as pdfjsLib from "pdfjs-dist";

window.pdfjsLib = pdfjsLib;

flatpickr.localize(German);

window.FilePond = FilePond;
window.FilePondPluginImagePreview = FilePondPluginImagePreview;
window.FilePondPluginFileValidateSize = FilePondPluginFileValidateSize;
window.FilePondPluginFileValidateType = FilePondPluginFileValidateType;

window.SignaturePad = SignaturePad;

window.Html5Qrcode = Html5Qrcode;

window.flatpickr = flatpickr;
window.Boarding = Boarding;

Alpine.plugin(Clipboard);
Alpine.plugin(Tooltip);
Alpine.plugin(ui);
Livewire.start();
